import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import qs from 'qs'
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}
const options = {
  lock: true,
  text: 'Loading',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)'
}
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  sendSuscced: true,
  retry: 4,
  retryDelay: 1000,
  onDownloadProgress: (progress) => {
    const downProgress = ((progress.loaded / progress.total) * 100).toFixed(2) || 0
    store.dispatch('cockpit/setDownProgress', downProgress)
  }
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    const options = {
      ...config.data,
      ...config.params
    }
    config.headers['platform'] = '4'
    config.headers['version'] = '1.0.0'
    config.headers['appId'] = store.state.user.appId
    const webLogin = sessionStorage.getItem('webLogin')
    if (webLogin && webLogin === 'true') {
      config.headers['userId'] = 'manager1109'
      config.headers['orgId'] = 'dingfbf583cb27062cdfbc961a6cb783455b'
      config.orgId = 'dingfbf583cb27062cdfbc961a6cb783455b'
      // config.headers['Authorization'] = 'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyIjp7Im9wZW5JZCI6ImRBbVBZS0xBQnJka2FKV3Ria1FQbHdpRWlFIiwidXNlcklkIjoiMDU1MzE0NTc1MTM3MzgwMDQiLCJuaWNrTmFtZSI6Inpob3UiLCJwb3NpdGlvbiI6bnVsbCwiYXZhdGFyVXJsIjoiaHR0cHM6Ly9zdGF0aWMtbGVnYWN5LmRpbmd0YWxrLmNvbS9tZWRpYS9sQURQRGhKenRHeWprM0hOQWJETkFiQV80MzJfNDMyLmpwZyIsInBob25lIjpudWxsLCJjb3VudHJ5IjpudWxsLCJwcm92aW5jZSI6bnVsbCwiY2l0eSI6bnVsbCwibWVyY2hhbnRBcHBJZCI6bnVsbCwiY29ycElkIjpudWxsLCJ0b2tlbiI6bnVsbCwiZXhwaXJlc0luIjpudWxsLCJzZXNzaW9uS2V5IjpudWxsLCJjdXJyZW50VGltZSI6bnVsbH0sImNyZWF0ZWQiOjE2MTI3NTU2ODYwNDgsImV4cCI6MTYxMjc1NTc0Nn0.pLAm4nTHAphlbfVTVbdXaMJ9puVGCMf7Bmd4Ed69DuRTj3Jd04mLnBsLc0cvrp5vpD_jJZYz1Exxm00m1npfXA'
      config.headers['Authorization'] = '2'
    }
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // console.log(getUSerToken())
      // config.headers['Authorization'] = getUSerToken()
      config.headers['Authorization'] = getToken()
    }
    if (sessionStorage.getItem('shopId')) {
      config.headers['shopid'] = sessionStorage.getItem('shopId')
    }
    // do something before request is sent
    if (config.type !== 'noKey') {
      config.headers.accept = 'application/json'
      if (config.method === 'post' || config.method === 'put') {
        if (config.headers['Content-Type'] === 'application/json') {
          config.data = options
        } else if (config.headers['Content-Type'] !== 'multipart/form-data') {
          config.data = options
          config.data = qs.stringify(config.data)
        }
        config.onUploadProgress = (progressEvent) => {
          config.callback && config.callback(progressEvent)
        }
      } else if (config.method === 'get') {
        config.params = options
      }
    }
    return config
  },
  (error) => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data
    if (!res.code) {
      if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
        return response
      } else {
        return res
      }
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== '1000' && res.code !== '7000') {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === '6003') {
        return res
      }
      if (res.code === '6004') {
        Message.warning('ip不在白名单请重新登录')
        store.dispatch('user/logout').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      }
      if (res.code === '401') {
        Loading.service(options)
        const loadingInstance = Loading.service(options)
        store.dispatch('user/logout').then(() => {
          loadingInstance.close()
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        // store.dispatch('user/logout').then(() => {
        //   loadingInstance.close()
        //   location.reload()
        // })
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === '50008' || res.code === '50012' || res.code === '50014') {
        // to re-login
        MessageBox.confirm(
          'You have been logged out, you can cancel to stay on this page, or log in again',
          'Confirm logout',
          {
            confirmButtonText: 'Re-Login',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      // return Promise.reject(new Error(res.message || 'Error'))
      return res
    } else {
      return res
    }
  },
  (error) => {
    if (error === undefined || error.code === 'ECONNABORTED') {
      Message.warning('服务请求超时')
      return Promise.reject(error)
    }
    const {
      response: {
        status,
        statusText,
        data: { message }
      }
    } = error
    const { response } = error
    const { dispatch } = store
    const text = message || codeMessage[status] || statusText || '服务器发生错误'
    const info = response.data
    if (status === 500) {
      Message.error(text)
    } else if (status === 404) {
      Message.error(text)
    } else if (status === 400) {
      Message.error(text + '，请退出重试')
      // message.warning('账户或密码错误！')
      // Loading.service(options)
      // const loadingInstance = Loading.service(options)
      // dispatch('user/ddlogin').then(() => {
      //   loadingInstance.close()
      //   location.reload()
      // })
    } else if (status === 401 || info.status === 40101) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        dispatch('user/logout').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
      // dispatch('user/logout').then(() => {
      //   location.reload() // 为了重新实例化vue-router对象 避免bug
      // })
    } else if (response.status === 504) {
      Message({
        message: '后端服务异常，请联系管理员！',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      Message({
        message: text || '后端服务异常，请联系管理员！',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return error
    // return Promise.reject(error)
  }
)

export default service
